(function($) {
	$.fn.panorama = function($options) {
		this.each(function(){
			var $settings = {
                control_display: 'auto',
                autostar: 1,
                direction:'left',
                container:$('.virtualTourContainer'),
                selectionEvent:function(){}
			};
			if($options) {
                $.extend($settings, $options);
            }
            $(this).hide();
            var $tour = [];
            $(this).find('room').each(function() {
                var $objTour = {};
                var $that = $(this);
                $objTour.active = $that.attr('active');
                $objTour.name = $that.attr('name');
                $objTour.title = $that.attr('title');
                $objTour.src = $that.attr('src');
                $objTour.width = $that.attr('width');
                $objTour.height = $that.attr('height');
                $objTour.start = $that.attr('start');
                var $areas = [];
                $that.find('area').each(function() {
                    var $objArea = {};
                    var $that = $(this);
                    $objArea.coords = $that.attr('coords');
                    $objArea.room = $that.attr('room');
                    $areas.push($objArea);
                });
                $objTour.areas = $areas;
                $tour.push($objTour);
            });
            var $selected;
            $($tour).each(function($i, $v){
                if($v.active == 1){
                    $selected = $v;
                    return false;
                }
            });
            select_room($tour, $settings, $selected);
        });
        function select_room($tour, $settings, $selected) {
            var $panoramaImages = $settings.container.find('.panorama-images');
            $panoramaImages.html('');
            $panoramaImages.append('<img src="' + $selected.src + '" style="width: '+$selected.width+'px;height: '+$selected.height+'px;">');
            $panoramaImages.append('<img src="' + $selected.src + '" style="width: '+$selected.width+'px;height: '+$selected.height+'px;">');
            $panoramaImages.find('img').each(function () {
                var $that = $(this);
                $that.attr('unselectable', 'on')
                    .css('position', 'relative')
                    .css('-moz-user-select', 'none')
                    .css('-webkit-user-select', 'none')
                    .css('margin', '0')
                    .css('padding', '0')
                    .css('border', 'none');
            });
            var $panoramaTitle = $settings.container.find('.panorama-title');
            $panoramaTitle.html($selected.title);
            var $panoramaContainer = $settings.container.find('.panorama-container');
            $panoramaContainer.css('height', $selected.height + 'px')
                .css('overflow', 'hidden');
            var $panoramaViewport = $settings.container.find('.panorama-viewport');
            $panoramaViewport.css('width', '100%')
                .css('overflow', 'hidden');
            var $mouseMove = false;
            var $mouseMoveStart = 0;
            $panoramaViewport.mousedown(function($e){
                if (!$mouseMove) {
                    $mouseMove = true;
                    $mouseMoveStart = $e.clientX;
                }
                return false;
            }).mouseup(function(){
                $mouseMove = false;
                $mouseMoveStart = 0;
                return false;
            }).mousemove(function($e){
                if ($mouseMove){
                    var $delta = parseInt(($mouseMoveStart - $e.clientX)/30);
                    if (($delta>10) || ($delta<10)) {
                        var $newMarginLeft = parseInt($panoramaContainer.css('marginLeft')) + ($delta);
                        if ($newMarginLeft > 0) {$newMarginLeft = - $selected.width;}
                        if ($newMarginLeft < -$selected.width) {$newMarginLeft = 0;}
                        $panoramaContainer.css('marginLeft', $newMarginLeft+'px');
                    }
                }
            }).bind('contextmenu',function($e){
                $e.preventDefault();
                $panoramaContainer.stop();
                var $start = (-1 * parseInt($panoramaContainer.css('marginLeft')));
                $settings.selectionEvent($e, $start);
                return false;
            });
            $panoramaViewport.css('height', $selected.height+'px')
                .css('overflow', 'hidden');
            $panoramaViewport.bind('click', function() {
                $panoramaContainer.stop();
            });
            $panoramaViewport.find('a.panorama-control-pause')
                .bind('click', function() {
                    $panoramaContainer.stop();
                    return false;
                });
            $panoramaViewport.find('a.panorama-control-left')
                .bind('click', function() {
                    $panoramaContainer.stop();
                    panorama_animate($panoramaContainer, $selected.width, 'right');
                    return false;
                });
            $panoramaViewport.find('a.panorama-control-right')
                .bind('click', function() {
                    $panoramaContainer.stop();
                    panorama_animate($panoramaContainer, $selected.width, 'left');
                    return false;
                });
            if($settings.control_display == 'yes') {
                $panoramaViewport.find('.panorama-control').show();
            }
            if($settings.control_display == 'auto') {
                $panoramaViewport.bind('mouseover', function(){
                    $panoramaViewport.find('.panorama-control').show();
                    return false;
                }).bind('mouseout', function(){
                    $panoramaViewport.find('.panorama-control').hide();
                    return false;
                });
            }
            $panoramaContainer.css('margin-left', '-'+$selected.start+'px');
            if($settings.autostar == 1){
                panorama_animate($panoramaContainer, $selected.width, $settings.direction);
            }
            var $panoramaCoord = $settings.container.find('.panorama-coord');
            $panoramaCoord.html('');
            var $id = 1;
            $($selected.areas).each(function($i, $v){
                var $coordsArr = coords_fill($v.coords);
                var $coordsRoom = '"'+$v.room+'"';
                $panoramaCoord.append("" +
                    "<a class='panorama-area area"+$id+"' target="+$coordsRoom+" " +
                    "style='position: absolute; " +
                    "left: "+$coordsArr[0]+"px; " +
                    "top: "+$coordsArr[1]+"px; " +
                    "width: "+($coordsArr[2]-$coordsArr[0])+"px; " +
                    "height: "+($coordsArr[3]-$coordsArr[1])+"px;' " +
                    "</a>");
            });
            $panoramaCoord.find('a').unbind()
                .click(function(){
                    var $that = $(this);
                    var $target = $that.attr('target');
                    $($tour).each(function($i, $v){
                        if($v.name == $target){
                            $selected = $v;
                            return false;
                        }
                    });
                    select_room($tour, $settings, $selected);
                }).mouseover(function(){
                var $that = $(this);
                $that.addClass('panorama-area-hover');
            }).mouseout(function(){
                var $that = $(this);
                $that.removeClass('panorama-area-hover');
            });
        }
        function panorama_animate($ele, $eleW, $direction) {
            var $cP = 0 - parseInt($ele.css('margin-left'));
            if ($direction == 'right') {
                $ele.animate({marginLeft: 0}, ((55000 / $eleW) * ($cP)) , 'linear', function (){
                    $ele.css('marginLeft', '-'+(parseInt($eleW)+'px'));
                    panorama_animate($ele, $eleW, $direction);
                });
            } else {
                var $rL = $eleW;
                $ele.animate({marginLeft: - $rL}, ((55000 / $rL) * ($rL - $cP)), 'linear', function (){
                    $ele.css('margin-left', 0);
                    panorama_animate($ele, $eleW, $direction);
                });
            }
        }
        function coords_fill($mycoords) {
            var $position1=0;
            var $position2=0;
            var $result = new Array();
            while (($position2 = $mycoords.indexOf(',', $position1)) >= 0) {
                $result.push($mycoords.substring($position1, $position2));
                $position1 = $position2+1;
                $position2 = $position1+1;
            }
            $result.push($mycoords.substring($position1));
            return $result;
        }
    };
})(jQuery);
